/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateGroup200Response,
  CreateGroupRequest,
  GetGroup200Response,
  ListGroupCompanies200Response,
  ListGroupCompanyConditions200Response,
  ListGroups200Response,
  ListOperations400Response,
  UpdateCompaniesRequest,
  UpdateGroup200Response,
  UpdateGroupRequest,
} from '../models/index';
import {
    CreateGroup200ResponseFromJSON,
    CreateGroup200ResponseToJSON,
    CreateGroupRequestFromJSON,
    CreateGroupRequestToJSON,
    GetGroup200ResponseFromJSON,
    GetGroup200ResponseToJSON,
    ListGroupCompanies200ResponseFromJSON,
    ListGroupCompanies200ResponseToJSON,
    ListGroupCompanyConditions200ResponseFromJSON,
    ListGroupCompanyConditions200ResponseToJSON,
    ListGroups200ResponseFromJSON,
    ListGroups200ResponseToJSON,
    ListOperations400ResponseFromJSON,
    ListOperations400ResponseToJSON,
    UpdateCompaniesRequestFromJSON,
    UpdateCompaniesRequestToJSON,
    UpdateGroup200ResponseFromJSON,
    UpdateGroup200ResponseToJSON,
    UpdateGroupRequestFromJSON,
    UpdateGroupRequestToJSON,
} from '../models/index';

export interface CreateGroupOperationRequest {
    createGroupRequest: CreateGroupRequest;
}

export interface GetGroupRequest {
    id: string;
    page?: number;
    count?: number;
    sort?: GetGroupSortEnum;
}

export interface ListGroupCompaniesRequest {
    id: string;
}

export interface ListGroupCompanyConditionsRequest {
    id: string;
}

export interface ListGroupsRequest {
    page?: number;
    count?: number;
    sort?: ListGroupsSortEnum;
    id?: string;
    companyName?: string;
    paymentGroupName?: string;
}

export interface UpdateCompaniesOperationRequest {
    id: string;
    updateCompaniesRequest: UpdateCompaniesRequest;
}

export interface UpdateGroupOperationRequest {
    ifMatch: number;
    id: string;
    updateGroupRequest: UpdateGroupRequest;
}

/**
 * 
 */
export class GroupsApi extends runtime.BaseAPI {

    /**
     * PG登録
     */
    async createGroupRaw(requestParameters: CreateGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateGroup200Response>> {
        if (requestParameters['createGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'createGroupRequest',
                'Required parameter "createGroupRequest" was null or undefined when calling createGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/groups`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateGroupRequestToJSON(requestParameters['createGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateGroup200ResponseFromJSON(jsonValue));
    }

    /**
     * PG登録
     */
    async createGroup(requestParameters: CreateGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateGroup200Response> {
        const response = await this.createGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PG会社詳細
     */
    async getGroupRaw(requestParameters: GetGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGroup200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGroup200ResponseFromJSON(jsonValue));
    }

    /**
     * PG会社詳細
     */
    async getGroup(requestParameters: GetGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGroup200Response> {
        const response = await this.getGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PG連携会社一覧
     */
    async listGroupCompaniesRaw(requestParameters: ListGroupCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListGroupCompanies200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listGroupCompanies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/groups/{id}/companies`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListGroupCompanies200ResponseFromJSON(jsonValue));
    }

    /**
     * PG連携会社一覧
     */
    async listGroupCompanies(requestParameters: ListGroupCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListGroupCompanies200Response> {
        const response = await this.listGroupCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PG連携会社一覧
     */
    async listGroupCompanyConditionsRaw(requestParameters: ListGroupCompanyConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListGroupCompanyConditions200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listGroupCompanyConditions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/groups/{id}/companies/conditions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListGroupCompanyConditions200ResponseFromJSON(jsonValue));
    }

    /**
     * PG連携会社一覧
     */
    async listGroupCompanyConditions(requestParameters: ListGroupCompanyConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListGroupCompanyConditions200Response> {
        const response = await this.listGroupCompanyConditionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ペイメントグループ一覧
     */
    async listGroupsRaw(requestParameters: ListGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListGroups200Response>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['companyName'] != null) {
            queryParameters['company_name'] = requestParameters['companyName'];
        }

        if (requestParameters['paymentGroupName'] != null) {
            queryParameters['payment_group_name'] = requestParameters['paymentGroupName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/groups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListGroups200ResponseFromJSON(jsonValue));
    }

    /**
     * ペイメントグループ一覧
     */
    async listGroups(requestParameters: ListGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListGroups200Response> {
        const response = await this.listGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * PG連携会社更新
     */
    async updateCompaniesRaw(requestParameters: UpdateCompaniesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCompanies().'
            );
        }

        if (requestParameters['updateCompaniesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCompaniesRequest',
                'Required parameter "updateCompaniesRequest" was null or undefined when calling updateCompanies().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/groups/{id}/companies`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCompaniesRequestToJSON(requestParameters['updateCompaniesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * PG連携会社更新
     */
    async updateCompanies(requestParameters: UpdateCompaniesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCompaniesRaw(requestParameters, initOverrides);
    }

    /**
     * PG編集
     */
    async updateGroupRaw(requestParameters: UpdateGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateGroup200Response>> {
        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling updateGroup().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateGroup().'
            );
        }

        if (requestParameters['updateGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'updateGroupRequest',
                'Required parameter "updateGroupRequest" was null or undefined when calling updateGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGroupRequestToJSON(requestParameters['updateGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateGroup200ResponseFromJSON(jsonValue));
    }

    /**
     * PG編集
     */
    async updateGroup(requestParameters: UpdateGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateGroup200Response> {
        const response = await this.updateGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetGroupSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetGroupSortEnum = typeof GetGroupSortEnum[keyof typeof GetGroupSortEnum];
/**
 * @export
 */
export const ListGroupsSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListGroupsSortEnum = typeof ListGroupsSortEnum[keyof typeof ListGroupsSortEnum];
